// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-597cfb7e] {\n  margin: 1.2em 0;\n}\n.is-bottom[data-v-597cfb7e] {\n  height: 280px;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  justify-self: stretch;\n}\n.subtext[data-v-597cfb7e] {\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
